/* Window shelf · Storiarts · progressive enhancement only; the section reads fully without this. */
(function () {
  'use strict';

  function track(name, el) {
    var detail = { event: name, shelf: el.getAttribute('data-shelf') || '', product: el.getAttribute('data-product') || '' };
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(detail); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('window-shelf:' + name, { detail: detail })); } catch (e) {}
  }

  function dragScroll(el) {
    var down = false, moved = false, sx = 0, sl = 0, pid = null, restore = null;
    el.classList.add('ws-draggable');
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; sx = e.clientX; sl = el.scrollLeft; pid = e.pointerId;
      clearTimeout(restore); el.style.scrollSnapType = 'none'; el.style.scrollBehavior = 'auto';
    });
    el.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (!moved && Math.abs(dx) > 4) { moved = true; el.classList.add('is-dragging'); try { el.setPointerCapture(pid); } catch (x) {} }
      if (moved) el.scrollLeft = sl - dx;
    });
    function up() {
      if (!down) return;
      down = false; el.classList.remove('is-dragging');
      try { el.releasePointerCapture(pid); } catch (x) {}
      var pad = parseFloat(getComputedStyle(el).paddingLeft) || 0, best = null, bd = 1e9;
      Array.prototype.forEach.call(el.children, function (c) { var d = Math.abs(c.offsetLeft - pad - el.scrollLeft); if (d < bd) { bd = d; best = c; } });
      if (best && moved) { el.style.scrollBehavior = 'smooth'; el.scrollLeft = best.offsetLeft - pad; }
      restore = setTimeout(function () { el.style.scrollSnapType = ''; el.style.scrollBehavior = ''; }, 450);
    }
    el.addEventListener('pointerup', up); el.addEventListener('pointercancel', up); el.addEventListener('lostpointercapture', up);
    el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }

  function init(root) {
    if (!root || root.dataset.wsReady) return;
    root.dataset.wsReady = '1';
    var rail = root.querySelector('[data-ws-rail]');
    if (!rail) return;
    var slides = rail.querySelectorAll('.ws-slide');
    var spreads = root.querySelectorAll('[data-ws-spread]');
    var openIndex = -1, closeTimer = null;

    /* lamp colour and parallax follow the rail */
    function onScroll() {
      var x = rail.scrollLeft;
      root.style.setProperty('--ws-px', x);
      var w = slides.length ? slides[0].getBoundingClientRect().width : rail.clientWidth;
      var i = Math.max(0, Math.min(slides.length - 1, Math.round(x / Math.max(1, w))));
      var lamp = slides[i] && slides[i].getAttribute('data-lamp');
      if (lamp) root.style.setProperty('--ws-lamp', lamp);
    }
    rail.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    dragScroll(rail);

    /* the dealt-out shelf */
    function closeSpread() {
      if (openIndex < 0) return;
      var sp = root.querySelector('[data-ws-spread="' + openIndex + '"]');
      openIndex = -1;
      if (!sp) return;
      sp.classList.remove('is-open');
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { sp.hidden = true; }, 420);
    }
    function openSpread(i) {
      var sp = root.querySelector('[data-ws-spread="' + i + '"]');
      if (!sp) return;
      if (openIndex === i) { closeSpread(); return; }
      if (openIndex >= 0) { var prev = root.querySelector('[data-ws-spread="' + openIndex + '"]'); if (prev) { prev.classList.remove('is-open'); prev.hidden = true; } }
      clearTimeout(closeTimer);
      openIndex = i;
      sp.hidden = false;
      sp.classList.remove('is-open'); void sp.offsetWidth; sp.classList.add('is-open');
      var books = sp.querySelector('[data-ws-books]');
      if (books) books.scrollLeft = 0;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      try { sp.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
    }
    Array.prototype.forEach.call(spreads, function (sp) { var b = sp.querySelector('[data-ws-books]'); if (b) dragScroll(b); });

    root.addEventListener('click', function (e) {
      var see = e.target.closest('[data-ws-see]');
      if (see && root.contains(see)) {
        e.preventDefault();
        track('window_see_shelf', see.closest('.ws-slide') || see);
        openSpread(parseInt(see.getAttribute('data-ws-see'), 10));
        return;
      }
      if (e.target.closest('[data-ws-gather]')) { closeSpread(); return; }
      var book = e.target.closest('[data-ws-book]');
      if (book) { track('window_book_click', book); return; }
      var sb = e.target.closest('[data-ws-shelf-book]');
      if (sb) { track('window_shelf_book_click', sb); }
    });
  }

  function initAll() { Array.prototype.forEach.call(document.querySelectorAll('[data-ws]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector('[data-ws]'); if (r) { delete r.dataset.wsReady; init(r); } });
})();
